export default __webpack_public_path__ + "static/media/stp_logo.459ff51d.png";